import React, { useEffect, useState } from 'react';
import Footer from './Footer';
import { useReferralGetDataQuery } from './store/ReduxApis';
import { TablePagination } from '@material-ui/core';

function Referral() {
    const wallet = useReferralGetDataQuery();
    const explorerBaseUrl = "https://testnet.bscscan.com";
    const [userAddress, setUserAddress] = useState("");
    const [txAddress, setTxAddress] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [amount, setAmount] = useState("");
    const [status, setStatus] = useState("");
    const [date, setDate] = useState("");

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const formatDate = (timestamp) => new Date(Number(timestamp)).toLocaleDateString();

    return (
        <div>
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6 text">
                                <h1>Referral Transactions Info</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item active">Referral Transactions Info</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header cards">
                                        <h3 className="card-title">Get all Referral Transactions details</h3>
                                    </div>

                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <div className="pagination">
                                                <h6 className="page">Show 1 to {wallet?.data?.message?.length} entries</h6>
                                                <TablePagination
                                                    className="pagi"
                                                    rowsPerPageOptions={[5, 10, 30]}
                                                    component="div"
                                                    count={wallet?.data?.message?.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onChangePage={handleChangePage}
                                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                                />
                                            </div>

                                            <table id="example" className="table table-bordered table-striped table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>From</th>
                                                        <th>To</th>
                                                        <th>Date</th>
                                                        <th>Amount</th>
                                                        <th>TxId</th>
                                                        <th>Transaction Hash</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {wallet && wallet?.data?.message?.filter((value) => {
                                                        const transactionDate = formatDate(value.timestamp);
                                                        const matchDate = date === "" || transactionDate.includes(date);
                                                        const matchAmount = amount === "" || value.targetAmount.toString().includes(amount);
                                                        const matchTxId = searchTerm === "" || value.txid.toLowerCase().includes(searchTerm.toLowerCase());
                                                        const matchStatus = status === "" || value.status.toLowerCase().includes(status.toLowerCase());
                                                        const matchFromAddress = userAddress === "" || value.from.toLowerCase().includes(userAddress.toLowerCase());
                                                        const matchTxAddress = txAddress === "" || value.from.toLowerCase().includes(txAddress.toLowerCase());

                                                        return (
                                                            matchDate &&
                                                            matchAmount &&
                                                            matchTxId &&
                                                            matchStatus &&
                                                            matchFromAddress &&
                                                            matchTxAddress
                                                        );
                                                    }).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(e => (
                                                        <tr key={e.txid}>
                                                            <td>{`${e.from.slice(0, 6)}...${e.from.slice(-6)}`}</td>
                                                            <td>{`${e.to.slice(0, 6)}...${e.to.slice(-6)}`}</td>
                                                            <td>{formatDate(e.timestamp)}</td>
                                                            <td>{e.targetAmount} {e.target}</td>
                                                            <td>{e.txid ? `${e.txid.slice(0, 6)}...${e.txid.slice(-6)}` : "-"}</td>
                                                            <td>
                                                                {`${e.txHash.slice(0, 5)}...${e.txHash.slice(-5)}`}
                                                                <button
                                                                    className="btn btn-sm btn-outline-primary ms-2"
                                                                    onClick={() =>
                                                                        window.open(`${explorerBaseUrl}/tx/${e.txHash}`, "_blank")
                                                                    }
                                                                >
                                                                    View
                                                                </button>
                                                            </td>
                                                            <td>{e.status ? e.status.charAt(0).toUpperCase() + e.status.slice(1).toLowerCase() : "-"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>

                                                <tfoot>
                                                    <tr>
                                                        <th>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={(e) => setUserAddress(e.target.value)}
                                                                autoComplete="off"
                                                                placeholder="From Address"
                                                            />
                                                        </th>
                                                        <th>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={(e) => setTxAddress(e.target.value)}
                                                                autoComplete="off"
                                                                placeholder="Tx Address"
                                                            />
                                                        </th>
                                                        <th>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={(e) => setDate(e.target.value)}
                                                                autoComplete="off"
                                                                placeholder="Date"
                                                            />
                                                        </th>
                                                        <th>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={(e) => setAmount(e.target.value)}
                                                                autoComplete="off"
                                                                placeholder="Amount"
                                                            />
                                                        </th>
                                                        <th>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                                autoComplete="off"
                                                                placeholder="TxId"
                                                            />
                                                        </th>
                                                        <th>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                                autoComplete="off"
                                                                placeholder="Transaction Hash"
                                                            />
                                                        </th>
                                                        <th>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                onChange={(e) => setStatus(e.target.value)}
                                                                autoComplete="off"
                                                                placeholder="Status"
                                                            />
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        </div>
    );
}

export default Referral;
